import type { WordCloudData } from '@mentimeter/visualizations';
import { useTranslations } from 'next-intl';

interface ScreenReaderResultsProps {
  results: WordCloudData[];
  shouldHideResults: boolean;
}

export const ScreenReaderResults = ({
  results,
  shouldHideResults,
}: ScreenReaderResultsProps) => {
  const translate = useTranslations('presenting.screenreader_table');

  if (shouldHideResults) {
    return <span>{translate('results_are_hidden_message')}</span>;
  }

  return (
    <table>
      <caption>{translate('results_table_caption')}</caption>
      <thead>
        <tr>
          <th scope="col">{translate('word_column_title')}</th>
          <th scope="col">{translate('occurrences_count_column_title')}</th>
        </tr>
      </thead>
      <tbody>
        {results.map((response) => (
          <tr key={response.key}>
            <th scope="row">{response.text}</th>
            <td>{response.value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
